import { render, staticRenderFns } from "./TicketsDraft.vue?vue&type=template&id=5c69a126&"
import script from "./TicketsDraft.vue?vue&type=script&lang=js&"
export * from "./TicketsDraft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports